import { render, staticRenderFns } from "./SpeedGraph.vue?vue&type=template&id=67d8c6fb&"
import script from "./SpeedGraph.vue?vue&type=script&lang=js&"
export * from "./SpeedGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports